angular.module('iw.frontyard.signup')
    .directive('iwOnDefinedStyleParent', function () {
        return {
            restrict: 'EA',
            controller: function ($element) {

                this.addClass = function (className) {
                    $element.addClass(className);
                };

                this.removeClass = function (className) {
                    $element.removeClass(className);
                };

            }
        };
    })
    .directive('iwOnDefinedStyle', function () {
        return {
            restrict: 'EA',
            require: ['ngModel', '^^iwOnDefinedStyleParent'],
            link: function (scope, element, attributes, controllers) {
                var ngModelController = controllers[0];
                var parentController = controllers[1];
                var className = attributes.iwOnDefinedStyle;

                element.on('input', function () {
                    if (this.value !== '') {
                        parentController.addClass(className);
                    } else {
                        parentController.removeClass(className);
                    }
                });

            }
        };
    });